<template>
    <div class="joinus">
        <div style="position: relative;height:2rem">
            <img
                class="bannerImg"
                src="../assets/images/joinus.png"
                alt=""
            />
            <div class="banners">
                <img class="bannerImg" src="../assets/images/joinus-title.png" />
            </div>
        </div>
        <div class="page_wrap">
            <div class="page_content page_wrap-joinus" style="margin-top: 0.4rem;">
                <div class="joinus-jobType-wrap joinus-left">
                    <div 
                        v-for="item in jobTypeList" 
                        :key="item" 
                        class="joinus-jobType-item" 
                        :class="{'joinus-jobType-item-active': item === nowType}" 
                        @click="changeJobType(item)"
                    >
                        {{ typeMap[item] }}
                    </div>
                    <div style="margin-top: 0.6rem;margin-left:0.1rem;border-left:2px solid #0061E3;padding-left: 0.2rem;">
                        <div class="joinus-jobType-item-title1">投递方式</div>
                        <div class="joinus-jobType-item-title2">公司招聘邮箱</div>
                        <div class="joinus-jobType-item-title3">shenhui@extrotec.com</div>
                    </div>
                </div>
                <div class="joinus-right">
                    <!-- 修复：添加加载状态提示 -->
                    <div v-if="jobList.length === 0 && !isLoading" class="no-data">
                        暂无岗位信息
                    </div>
                    <div v-if="isLoading" class="no-data">
                        加载中...
                    </div>
                    <div v-for="item in filteredJobList" :key="item.id || item.title" class="joinus-item">
                        <div class="joinus-item-title">{{item.title}} <span class="joinus-item-remark" v-if="item.remark">({{item.remark}})</span></div>
                        <div class="joinus-item-title-device"></div>
                        <div class="joinus-item-detail">
                            <div class="joinus-item-detail-duties" v-if="item.duties">
                                <div class="joinus-item-detail-duties-title joinus-item-label">岗位职责：</div>
                                <div class="joinus-item-detail-duties-content joinus-item-content">
                                    <div class="duty-item" v-for="(duty, index) in splitText(item.duties)" :key="index">
                                        {{ index + 1 }}. {{ duty }}
                                    </div>
                                </div>
                            </div>
                            <div class="joinus-item-detail-requirements" v-if="item.requirements">
                                <div class="joinus-item-detail-requirements-title joinus-item-label" style="margin-top: 0.2rem;">任职要求：</div>
                                <div class="joinus-item-detail-requirements-content joinus-item-content">
                                    <div class="requirement-item" v-for="(requirement, index) in splitText(item.requirements)" :key="index">
                                        {{ index + 1 }}. {{ requirement }}
                                    </div>
                                </div>
                            </div>
                            <div class="joinus-item-detail-other" v-if="item.other">{{ item.other }}</div>
                        </div>
                    </div>
                    <!-- 无数据提示 -->
                    <div v-if="filteredJobList.length === 0 && nowType !== null && jobList.length > 0" class="no-data">
                        暂无该类型的岗位信息
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import api from '@/api/api'
import DateUtils from "@/assets/filters/dateUtils";
export default {
    components:{},
    data(){
        return{
            nowType: null, // 现在存储的是类型数字（1/2/3...）
            jobTypeList:[], // 存储去重后的类型列表 [1,2,3...]
            jobList:[], // 存储所有岗位数据
            isLoading: false, // 加载状态
            // 类型映射表（抽离出来更易维护）
            typeMap: {
                1:'软件工程师',
                2:'算法工程师',
                3:'硬件工程师',
                4:'销售',
                5:'财务',
                6:'行政人事',
                7:'其他'
            }
        }
    },
    mounted(){
        this.queryList()
    },
    computed: {
        filteredJobList() {
            if (this.nowType === null) {
                return this.jobList // 初始显示全部
            }
            // 修复：比较 type 字段（数字）
            return this.jobList.filter(item => item.type === this.nowType)
        }
    },
    methods:{
        queryList(){
            this.isLoading = true
            api.getJobList({
                pageNum:1,
                pageSize:99
            }).then(res => {
                this.isLoading = false
                if(res.code === 200){
                    this.jobList = res.data.list || []
                    const types = [...new Set(this.jobList.map(item => item.type).filter(Boolean))]
                    this.jobTypeList = types.sort((a,b) => a - b) // 按数字排序
                }
            }).catch(err => {
                console.error('获取岗位列表失败：', err)
                this.isLoading = false
                this.jobList = []
                this.jobTypeList = []
            })
        },
        changeJobType(item){
            // 修复：item 现在是类型数字（1/2/3...）
            if (this.nowType === item) {
                this.nowType = null // 取消选中，显示全部
            } else {
                this.nowType = item // 选中该类型
            }
        },
        splitText(text){
            // 容错：处理 text 为 null/undefined 的情况
            if(!text) return []
            return text.split('|').filter(item => item.trim() !== '')
        }
    }
}
</script>

<style lang="scss" scoped>
.joinus{
    background: #F5F5F5;
    .bannerImg {
        height: 2rem;
        width: 100%; // 新增：保证banner图铺满
        object-fit: cover; // 新增：保持比例
    }
    .banners {
        width: 4rem;
        margin:0 auto;
        position: absolute;
        top: calc(50% - 0.3rem);
        left: calc(50% - 2rem);
        img {
            width:4rem; 
            height: 0.6rem;
            object-fit: contain; // 新增：保持比例
        }
    }
    .breadcrumb{
        width: 12rem;
        margin:0 auto;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #A8A8A8;
    }
}
.page_wrap{
    .page_content{
        width: 12rem;
        margin:0 auto;
        .content-single{
            margin-bottom: 0.4rem;
            background: #ffffff;
            cursor: pointer;

        }
        .pagination{
            display: flex;
            justify-content: center;
            padding-bottom: 0.6rem;
        }
    }
}
.page_wrap-joinus{
    padding: 0 0.4rem;
    display: flex;
    justify-content: space-between;
    min-height: 4rem;
}
.joinus-left{
    width: 3rem;
    // height: 4rem; // 移除固定高度，自适应内容
}
.joinus-right{
    width: calc(100% - 3.2rem); // 调整：增加间距
    min-height: 4rem;
    margin-left: 0.2rem; // 新增：左右间距
}
.joinus-jobType-wrap{
    // 新增：让分类项居中
    display: flex;
    flex-direction: column;
    align-items: center;
}
.joinus-jobType-item{
    padding:0.1rem 0.3rem;
    width: 1.6rem;
    text-align: center;
    font-size: 0.14rem;
    font-family: Source Han Sans CN;
    color: #333333;
    background: #F5F5F5;
    border: 1px solid #CAC8BC;
    margin-bottom: 0.2rem;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 4px; // 新增：圆角更美观
}
.joinus-jobType-item:hover{
    color: #0061E3;
    border: 1px solid #0061E3;
}
.joinus-jobType-item:active{
    color: #0061E3;
    background: #fff;
    border: 1px solid #0061E3;
}
.joinus-jobType-item-active{
    color: #0061E3;
    background: #fff;
    border: 1px solid #0061E3;
}
.joinus-item{
    padding:0.3rem;
    margin-bottom: 0.3rem;
    border-radius: 0.06rem;
    position: relative;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05); // 新增：轻微阴影
    .joinus-item-title{
        text-align: left;
        font-size: 0.18rem;
        color:#0061E3;
        font-family: Source Han Sans CN;
        font-weight: bold;
        margin-bottom: 0.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;            
    }
    
    .joinus-item-remark{
        font-size: 0.14rem;
        margin-left: 0.1rem;
        font-family: Source Han Sans CN;
        color: #333333;
        font-weight: normal; // 新增：取消加粗
    }
    .joinus-item-title-device{
        width: 100%;
        height: 0.02rem;
        margin-bottom: 0.2rem;
        background: linear-gradient(90deg, #0061E3 0%, #7FD9FF 100%);
    }
    .joinus-item-label{
        font-size: 0.15rem;
        font-family: Source Han Sans CN;
        color: #333333;
        font-weight: 600;
        margin: 0.1rem 0;
    }
    .joinus-item-content{
        font-size:0.14rem;
        font-family: Source Han Sans CN;
        color: #333333;
        line-height: 1.5; 
    }
    .duty-item, .requirement-item{
        margin-bottom: 0.05rem; 
    }
   
}
 .joinus-jobType-item-title1{
      font-weight: 700;
      font-size: 0.15rem;
    }
    .joinus-jobType-item-title2{
      font-weight: 400;
      font-size: 0.13rem;
      color: #666;
      margin:0.04rem 0;
    }
    .joinus-jobType-item-title3{
      font-weight: 700;
      font-size: 0.14rem;
      color: #0061E3;
    }
// 无数据提示样式
.no-data {
    text-align: center;
    padding: 1rem;
    color: #999;
    font-size: 0.14rem;
    background: #fff;
    border-radius: 0.06rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
@media screen and (min-width: 2000px) {
  .joinus-jobType-item{
     padding:0.08rem 0.26rem; 
  }
  .joinus-jobType-item-title1{
    font-size: 0.14rem;
  }

  .joinus-jobType-item-title2{
    font-weight: 400;
  }
  .joinus-jobType-item-title3{
    font-size: 0.13rem;
  }
  .joinus-item{
    .joinus-item-title{
        text-align: left;
        font-size: 0.16rem;
    }
    .joinus-item-remark{
        font-size: 0.13rem;
    }
    .joinus-item-label{
        font-size: 0.13rem;
    }
    .joinus-item-content{
        font-size:0.12rem;
    }
    .joinus-item-title-device{
        height: 0.02rem;
        margin-bottom: 0.16rem;
    }
  }
}
</style>

<style>
/* 加载动画关键帧 */
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.newslist .el-breadcrumb{
    line-height: 0.74rem;
}
.newslist .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
    color: #A8A8A8;
}
.newslist .el-breadcrumb__item:last-child .el-breadcrumb__inner a{
    color:#000000
}
.newslist .el-pagination .btn-prev{
    background: #F5F5F5;
}
.newslist .el-pagination .btn-next{
    background: #F5F5F5;
}
.newslist .el-pager li {
    background: #F5F5F5;
}
.el-pagination__editor.el-input .el-input__inner{
    background: #F5F5F5;
}

</style>